module.exports = __webpack_public_path__ + "static/media/gr_attenuation_1.f9a20c9b.png";